import { Form, Input, Switch } from "antd";
import "../../../styles/teamMember.scss";

const FormPosition = ({ code, setCode }) => {
  const [form] = Form.useForm();

  const handleChange = (e, name) => {
    const value = e.target.value;
    setCode({
      ...code,
      [name]: value,
    });
  };

  return (
    <Form
      labelAlign="left"
      form={form}
      requiredMark={false}
      labelCol={{ span: 5 }}
    >
      <Form.Item
        label="Description"
        name="description"
        rules={[{ required: true }]}
      >
        <Input onChange={(e) => handleChange(e, "description")} />
      </Form.Item>
      <Form.Item label="Type" name="type" rules={[{ required: true }]}>
        <Input onChange={(e) => handleChange(e, "type")} />
      </Form.Item>
      <Form.Item
        label="Code"
        name="code"
        rules={[
          {
            required: true,
            message: "The Code must not exceed 4 characters.",
            max: 3
          },
        ]}
      >
        <Input maxLength={3} onChange={(e) => handleChange(e, "code")} />
      </Form.Item>
      <Form.Item label="Status" name="status" valuePropName="checked">
        <Switch
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={(e) => handleChange(e, "status")}
        />
      </Form.Item>
    </Form>
  );
};

export default FormPosition;
